import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useHistory } from "react-router-dom";

const InnerComponment = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const InnerComponent = useSelector(
    (state) => state?.financeReducer?.innerComponentData
  );
  const grossSales =
    InnerComponent?.menuItems?.menu_item_quantity *
    InnerComponent?.menuItems?.menu_item_price;

  const netSales =
    grossSales -
    InnerComponent?.menuItems?.void -
    InnerComponent?.menuItems?.discount;

  console.log("netSales", netSales, grossSales, InnerComponent);
  useEffect(() => {
    return () => {
      dispatch(actions?.saveInnerComponentData(null));
    };
  }, []);
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  <div className="field text-right my-3 pt-1 px-0">
                    <button
                      onClick={() => history.goBack()}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to Items
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <h4 class="event-alert">
                            COMPONENTS <p class="billno-right">Item #23647</p>
                          </h4>
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12"></div>
                            <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>Last Upload July 13, 2022 02:23 PM</i>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>Components #</th>
                                    <th>Component Type</th>
                                    <th>Component Name </th>
                                    <th>Add/Remove</th>
                                    <th>Quantity</th>
                                    <th>Unit Price</th>
                                    <th>Gross Sales</th>
                                    <th>Void</th>
                                    <th>Discounts</th>
                                    <th>Net Sales</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>Menu Item</td>
                                    <td>
                                      {
                                        InnerComponent?.menuItems?.menu_item
                                          ?.menu_item_name
                                      }
                                    </td>
                                    <td>Add</td>
                                    <td>
                                      {
                                        InnerComponent?.menuItems
                                          ?.menu_item_quantity
                                      }
                                    </td>
                                    <td>
                                      {
                                        InnerComponent?.menuItems
                                          ?.menu_item_price
                                      }
                                    </td>
                                    <td>{grossSales}</td>
                                    <td>{InnerComponent?.menuItems?.void}</td>
                                    <td>
                                      {InnerComponent?.menuItems?.discount}
                                    </td>
                                    <td>{netSales}</td>
                                  </tr>
                                  {InnerComponent?.components?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{idx + 2}</td>
                                        <td>
                                          {el?.pos_menuitems_modifier?.type}
                                        </td>
                                        <td>
                                          {el?.pos_menuitems_modifier?.recipe
                                            ?.recipe_name ||
                                            el?.pos_menuitems_modifier
                                              ?.ingredient?.ingredient_name}
                                        </td>
                                        <td>
                                          {el?.pos_menuitems_modifier?.action}
                                        </td>
                                        <td>{el?.modifier_quantity}</td>
                                        <td>{el?.unit_price}</td>
                                        <td>{el?.gross_sale}</td>
                                        <td>{el?.void}</td>
                                        <td>{el?.discounts}</td>
                                        <td>{el?.net_sales}</td>
                                        {/* <td>
                                          {" "}
                                          <a
                                            onClick={() => {
                                              history.push(
                                                "/finance/sales/order-payments/item"
                                              );
                                            }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites eye-icon"></i>
                                          </a>
                                        </td> */}
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default InnerComponment;
